<template>
<my-bets ref="getHandleChangeEvent" :vistables="vistables">
  <template slot="default" slot-scope="slotProps">
    <div v-if="slotProps.currentType == 'slip'" class="content_slip">
      <ul class="_list">
        <template v-if="$parent.getBetList.length > 0">
          <li v-for="(item,index) in $parent.getBetList" :key="index +'pp'" >
          <div class="posshowed" v-if="!lockStatusFun(item)"><span>{{ $t('dialog.locked')}}</span></div>
          <div class="_lock">
            <span class="close" @click="hancleCose(item,index)"><i class="el-icon-close"></i></span>
            <p class="dodlue">{{ item.teamname }} @<odds-page :odds="item.teamodds" style="display: inline-block;padding:0 5px;border-radius: 4px;" :type="'touzhu'"></odds-page></p>
            <p class="name">Winner</p>
            <p class="palyname">{{ item.matchName }}</p>
            <p style="color:#999">{{ item.season }}</p>
            <div class="_num">
              <el-popover placement="bottom-end" trigger="focus">
                <p> min {{ Number(item.limit[0]) }},max {{ Number(item.limit[1]) }}</p>
                <el-input-number v-model="item.money" :min="Number(item.limit[0])" :max="Number(item.limit[1])" label="描述文字" slot="reference"/>
              </el-popover>
              <div style="text-align:center">
                <span>{{ $t('betting.return')  }}</span><br />
                <span v-show="item.money != 0" style="font-weight:550;font-size:16px">{{ (item.money*item.teamodds).toFixed(2) }}</span>
              </div>
            </div>
            <div class="hint" v-loading="loading" >
              <template v-if="item.betFailText">
                <i class="el-icon-warning"></i>
                <span>&nbsp;{{ item.betFailText }}</span>
              </template>
            </div>
          </div>
          </li>
        </template>
        <template v-else>
          <li class="empty">
          <no-data 
          :nodata_ind="'newHome.Cicket.empty_r'"
          :nodataTow="'newHome.Cicket.empty'"
          :Top="'40px'"></no-data></li>
        </template>
      </ul>
      <div class="place_bet">
        <div class="num_money">
          <p><span>{{ $t('betting.settleType.NumberofBets')}}</span><span>{{ againListVo.length }}</span></p>
          <p><span>{{ $t('betting.Total') }} {{ $t('betting.settleType.cost')}}</span><span>{{ getCost }}</span></p>
          <p style="color: #fff;font-weight:550;"><span>{{ $t('betting.Total') }} {{ $t('betting.return')  }}</span><span>{{ getReturn }}</span></p>
        </div>
        <div class="refer">
          <div class="_chicked">
            <el-checkbox v-model="ischicked">{{ $t('newHome.Cicket.free')}}</el-checkbox>
          </div>
          <p @click="handleGoBet" class="placebets">{{ $t('betting.settleType.PlaceBets')}}</p>
          <p @click="$parent.handleClearAll()" class="clearall">{{ $t('betting.settleType.ClearAll')}}</p>
        </div>
      </div>
    </div>
  </template>
</my-bets>
</template>
<script>
import oddsPage from '../odds';
import MyBets from './mybets'
import NoData from '../../NoData'
import { mapState,mapMutations } from 'vuex'
export default {
  components:{ MyBets,NoData,oddsPage },
  props:{
    againListVo:{
    type:Array,
    default:()=>[]
    },
    createdAgainListVo:{
      type:Function,
      default:()=>{}
    }
  },
  data(){
    return{
      ischicked:true,
      loading:false,
      vistables:false,
      timer:null,
    }
  },
    computed: {
      ...mapState({
        UUID: state => state.UUID,
        isLogin: state => state.isLogin,
        mainBalance: (state) => state.userInfo.assetsInfoMap.mainBalance,
      }),
      getReturn(){
        let every = 0
        this.againListVo.forEach((item,i)=>{
          every += item.teamodds*item.money
        })
        return every.toFixed(2)
      },
      getCost(){
        let val = 0
        this.againListVo.forEach((item,i)=>{
          val += item.money
        })
        return val
      },
    
    },
    methods:{
      ...mapMutations(["setshowloginfloat2",]),
      lockStatusFun(item){
        let isbet =['live','not_started']
        if(item.defaultType == '2'){
          if(item.marketStatus == 'Active' && item.active) return true
          else return false
        }else if(item.defaultType == '1'){
          if(isbet.includes(item.matchStatus) && item.active) return true
          else return false
        }
      },
      commondata(item,listVo){
        let obj = {
          teamId:item.teamId,
          onlyKey:item.onlyKey,
          srMatch:item.srMatch,
          betAmount:item.money, 
          betOdds:item.teamodds,
          srMarKet:item.srMarket,
          lastUpdate:item.lastUpdate,
          betValueId:item.betValueId,
          matchStatus:item.matchStatus,
          latestOdd:Math.sign(this.ischicked),
        }
        listVo.push(obj)
      },
      DialogSetTimeOutFun(){
        let countdown = 1
        clearInterval(this.timer)
        this.timer = setInterval(()=>{
          countdown--;
          if(countdown <= 0){
            clearInterval(this.timer)
            this.vistables = false
          }
        }, 1000);
      },
      handleGoBet(){
        if(this.isLogin){
          let listVo = []
          this.$parent.getBetList.forEach(item=>{
            if(item.defaultType == '1'){ // 投注区主页
              let isbet =['live','not_started']
                if(isbet.includes(item.matchStatus) && item.active){
                  this.commondata(item,listVo)
                }
            }else if(item.defaultType == '2'){ //投注区 详情页
              if(item.marketStatus == 'Active' && item.active){
                this.commondata(item,listVo)
              }
            }
          })
          if(listVo.length <= 0) return this.$notify({ title:this.$t('notify.warning'),message:this.$t('newHome.Cicket.empty') });
          if(this.mainBalance >= this.getCost){
            this.loading = true
            this.$api.post(this.$urls.Cicket.getbettingList, {UUID:this.UUID,list_str:JSON.stringify(listVo)}, resp => {
              let data = resp.data
              if(data.code == 200){
                this.loading = false
                let getData = data.data
                this.$emit('handleRefer',{ getData,sessionData:this.$parent.getBetList,listVo })
                if(getData.find(b => b.code == 200)){
                  this.vistables = true;
                  this.DialogSetTimeOutFun();
                  this.$refs.getHandleChangeEvent.handleChange('bet')
                }
                this.$store.dispatch('getFirstInfo')
              }else{
                this.loading = false
                this.$notify({ title:this.$t('notify.error'),message:data.msg });
              }
            })  
          }else{
            this.$confirm(this.$t('betting.noEnoughMoney')+'?', this.$t('notify.warning'), {
              confirmButtonText: this.$t('discounts.confrim'),
              cancelButtonText: this.$t('discounts.cancel'),
              type: 'warning'
            }).then(() => {
              this.$router.push({ path:'/mine/deposit'})
            }).catch(() => {});
          }
        }else{
          this.setshowloginfloat2(true)
          this.$notify({ title:this.$t('notify.warning'), message:this.$t('newHome.login'), type: "warning",});
        }
      },
      hancleCose(val,index){ // 删除其中一个
        let childMatchKey = this.$parent.matchKey
        if(childMatchKey.includes(val.teamId)){
          childMatchKey.splice(index,1);
          this.$parent.getBetList = this.$parent.getBetList.filter(item=>{ return item.teamId != val.teamId })
          sessionStorage.setItem('betList', JSON.stringify(this.$parent.getBetList));
          this.createdAgainListVo()
        }
      }
    }
  }

</script>
<style lang="scss" scoped>
.content_slip{
  padding:0 18px;
  ._list{
    padding-top:10px;
    li{
      color: #222;
      position: relative;
      font-size: 14px;
      // padding:18px 15px;
      background:#fff;
      margin-bottom:12px;
      .posshowed{
        color:#fff;
        position: absolute;
        top:0;
        left:0;
        z-index:99;
        height:100%;
        width:100%;
        background-color:rgba(102, 157, 1,.7);
        background-image:url('../img/lock.png');
        // background-size:36px 40px;
        background-position: center;
        border-bottom:1px solid #f2f2f2;
        border-radius: 6px;
        span{
          position: absolute;
          bottom:32%;
          left:38%;
          font-weight: 600;
        }
      }
      ._lock{ 
        // width:90%;
        border:1px solid #f2f2f2;
        border-radius: 6px;
        margin:0px auto;
        padding:0px 15px;
        -webkit-text-stroke:.3px;
      }
      &.empty{
        border-bottom:1px solid #2a2d33;
        .nodata-com{  
          background: #37573f !important;
        }
      }
      .close{
        position:absolute;
        top:8px;
        right:8px;
        cursor: pointer;
        i{ font-size: 13px;color:#616161;font-weight: 600;}
      }
      p{ color:#666;margin-bottom:6px;}
      .dodlue{
        width:90%;
        color:#222;
        font-weight: 550;
        padding-top:15px;
        word-wrap:break-word
      }
      ._num{
        display:flex;
        justify-content: space-between;
        padding-top:15px;
        padding-bottom:10px;
      }
      .hint{
        // padding-bottom:20px;
        color:red;
      }
    }
  }
  .place_bet{
    font-size: 14px;
    // padding:15px;
    font-family: Roboto-Regular;
    .num_money{
      padding-bottom:15px;
      -webkit-text-stroke:.3px;
      p{ 
        display:flex;
        line-height: 32px;
        justify-content: space-between;
      }
    }
    .refer{
      width:94%;
      margin:0 auto;
      .placebets,.clearall{ 
        text-align: center;
        cursor: pointer;
        -webkit-text-stroke: .3px;
      }
      .placebets{
        height:40px;
        line-height: 40px;
        margin-bottom:15px;
        // background-image:url('../img/btn_home_bet_p.png');
        // background-size:100%;
        background-color: #bebf01;
        color:#fff;
        -webkit-text-stroke: .5px;
      }
    }
  }
}
</style> 
<style lang="scss">
.content_slip ._list ._num{
  // .el-icon-minus,.el-icon-plus{ font-size: 16px!important;}
  .el-input-number{
    width:120px;
      line-height: 32px;
      height:32px;
    .el-input-number__decrease{
      width:32px;
      // background-image: linear-gradient(90deg,#80fbb4 0%,#c3fd7c 100%);
      left:0;
      i{ font-size:10px;font-weight: bold;color:#222;-webkit-text-stroke: 1px;}
    }
    .el-input-number__increase{
      width:32px;
      right:0;
      // background-image: linear-gradient(90deg,#80fbb4 0%,#c3fd7c 100%);
      i{ color:#222;font-size:10px;font-weight: bold;-webkit-text-stroke: 1px;}
    }
    .el-input .el-input__inner{
      padding:0;
      line-height: 32px;
      height:32px;
      font-size: 16px;
      font-weight: 600;
      // border-color:#a5fc96;
    }
  }
}
._chicked{
  text-align: center;
  margin-bottom:10px;
  .el-checkbox__label{ color:#fff!important;font-size:14px;-webkit-text-stroke:.3px;}
  .el-checkbox__inner{
    width:20px!important;
    height:20px!important;
    &:hover{ border-color: #dcdfe6;}
  }
  .el-checkbox__input.is-checked .el-checkbox__inner{
    background:#bebf01;
    border:none;
    &::after{
      border:2px solid #fff;
      border-left: 0;
      border-top: 0;
      height:12px;
      left:8px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/new-home/R-side/index.vue